import React, { useEffect, useState } from "react";
import { Box, Button, Card, Grid, Typography } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { guides } from "../../../../services/TicketsServices";
import PageWrapper from "../../../../common/PageWrapper/PageWrapper";

function FieldItem({ label, value }) {
  return (
    <Grid item xs={12} sm={6}>
      <Typography sx={{ color: "#777", fontSize: 12, mb: 0.5 }}>{label}</Typography>
      <Typography sx={{ color: "#111" }}>{value ?? "-"}</Typography>
    </Grid>
  );
}

function formatDateTime(value) {
  if (!value) return "-";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return value;
  return new Intl.DateTimeFormat(undefined, {
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  }).format(d);
}

export default function GuideDetailsPage() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!id) return;

    let cancelled = false;

    guides("get", null, null, id)
      .then((res) => {
        if (cancelled) return;
        setData(res?.data || null);
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error("Failed to fetch guide detail:", err);
        if (cancelled) return;
        setData(null);
      });

    return () => {
      cancelled = true;
    };
  }, [id]);

  return (
    <PageWrapper>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
        <Typography variant="h6">Guide Detail</Typography>
        <Button variant="outlined" onClick={() => navigate(-1)}>
          Back
        </Button>
      </Box>

      <Card className={"box-shadow"} sx={{ p: 3 }}>
        <Grid container spacing={2}>
          <FieldItem label="Name" value={data?.name} />
          <FieldItem label="Phone" value={data?.phone} />
          <FieldItem label="Agent name" value={data?.agent_name} />
          <FieldItem label="Active" value={data?.is_active ? "Yes" : "No"} />
          <FieldItem label="Created at" value={formatDateTime(data?.created_at)} />
          <FieldItem label="Updated at" value={formatDateTime(data?.updated_at)} />
        </Grid>
      </Card>
    </PageWrapper>
  );
}
